<template>
  <div class="box">
    <!--退回-->
    <!-- <div class="box_top_info">
			<img
				class="back_img"
				src="@/assets/homeImgs/black_back.png"
				@click="backToLast"
			/>
			<div class="person_info">个人资料</div>
		</div> -->
    <div class="avatar" @click="clickToReplace">
      <img class="avatar_picture" :src="wechatUser.headimgurl" />
      <!--<div class="avatar_text">点击更换头像</div>-->
    </div>
    <div class="personInfo_account">
      <div class="account_text">
        <!--账号-->
        <div class="account">账号</div>
        <div class="account_value">
          {{ userName }}
        </div>
      </div>
    </div>
    <div class="personInfo_name">
      <div class="name_text">
        <!--真实姓名-->
        <div class="name">真实姓名</div>
        <div class="name_value">
          {{ realName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "personInfo",
  data() {
    return {
      userName: "",
      realName: "",
      wechatUser: {},
    };
  },
  mounted() {
    this.init();
    this.wechatUser = JSON.parse(localStorage.getItem("wechatUser")) || {};
  },
  methods: {
    //更换头像
    clickToReplace() {
      close("更换头像");
    },
    init: function() {
      this.userInfo = this.$store.state.userInfo_v2.user;
      this.userName = this.userInfo.userName;
      this.realName = this.userInfo.realName;
    },

    //保存
    save() {},

    //返回
    backToLast() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f4f6f9;
  height: 100%;

  .box_top_info {
    width: vw(750);
    height: vw(88);
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    text-align: center;

    .back_img {
      width: vw(28);
      height: vw(28);
      margin-left: vw(38);
      margin-top: vw(30);
    }

    .person_info {
      width: vw(120);
      height: vw(30);
      margin-top: vw(27);
      margin-left: vw(249);
      color: #333333;
      font-size: vw(30);
      font-family: Source Han Sans CN;
      opacity: 1;
    }
  }

  .avatar {
    background-color: #ffffff;
    width: vw(750);
    height: vw(314);
    margin-top: vw(2);

    .avatar_picture {
      background: #c0c4cc;
      width: vw(160);
      height: vw(160);
      border-radius: 50%;
      margin-top: vw(60);
      margin-left: vw(295);
    }

    .avatar_text {
      margin-top: vw(24);
      margin-left: vw(295);
      width: vw(288);
      height: vw(30);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      color: #c2c5cc;
      opacity: 1;
    }
  }

  .personInfo_account {
    margin-top: vw(20);
    width: vw(750);
    height: vw(110);
    background-color: #ffffff;

    .account_text {
      display: flex;
      align-content: center;
      flex-direction: row;
      justify-content: space-between;

      .account {
        color: #333333;
        font-size: vw(30);
        margin-left: vw(32);
        margin-top: vw(41);
        font-family: Source Han Sans CN;
        opacity: 1;
      }

      .account_value {
        color: #c2c5cc;
        font-size: vw(30);
        padding-right: vw(32);
        margin-top: vw(41);
        font-family: Source Han Sans CN;
        opacity: 1;
      }
    }
  }

  .personInfo_name {
    margin-top: vw(1);
    background-color: #ffffff;
    width: vw(750);
    height: vw(110);

    .name_text {
      display: flex;
      align-content: center;
      flex-direction: row;
      justify-content: space-between;

      .name {
        color: #333333;
        font-size: vw(30);
        margin-left: vw(32);
        margin-top: vw(40);
        font-family: Source Han Sans CN;
        opacity: 1;
      }

      .name_value {
        color: #c2c5cc;
        font-size: vw(30);
        padding-right: vw(32);
        margin-top: vw(41);
        font-family: Source Han Sans CN;
        opacity: 1;
      }
    }
  }

  .box_button_text {
    width: vw(686);
    height: vw(88);
    margin-top: vw(702);
    margin-left: vw(32);
    background-color: $theme-color;
    font-size: vw(30);
    font-family: Source Han Sans CN;
    color: #ffffff;
    border-radius: vw(8);
  }
}
</style>
